// extracted by mini-css-extract-plugin
module.exports = {"root":"view-header_root_3WkjY","button":"view-header_button_2VdBr","active":"view-header_active_Nkigs","btnExport":"view-header_btnExport_19fsR","mr":"view-header_mr_1hOS9"};